import { h, render, Component } from 'preact';
import TxrNavbar from './txr-navbar';
import { classNames, isValidPhoneNumberSpecified, checkRequiredInvalid, checkPhoneInvalid, checkEmail } from '../utils/utils';
import { appConfig } from '../app.config';
import TxrInput from './txr-input';
import TxrInputArea from './txr-input-area';
import TxrDropdown from './txr-dropdown';
import TxrRadioButton from './txr-radio-button';
import TxrCheckbox from './txr-checkbox';
import qs from 'qs';

import axios from 'axios';

class TxrTextUsForm extends Component {
    state = {
        isSubmitted: false,
        messageSent: false,
        messageError: false,
        selectedTopic: undefined,
        errors: {
            required: 'Required field',
            email: 'Please enter a valid e-mail',
            phone: 'Phone numbers must be 10 or 11 digits.'
        },
        topics: [
            { title: 'Sales', id: 0 },
            { title: 'Support', id: 1 },
            { title: 'Partnerships', id: 2 },
            { title: 'Media inquiry', id: 3 },
            { title: 'Feedback and suggestions', id: 4 },
            { title: 'Blog contributor', id: 5 },
            { title: 'Something else!', id: 6 }
        ],
        industries: [
            { title: 'Financial', id: 0 },
            { title: 'Fitness', id: 1 },
            //  { title: 'Small Business', id: 2, class: 'dropdown-item__bottom-padding'},
            //  { title: 'Alpha Order', id: 3, class: 'dropdown-item__top-border'}, 
            { title: 'Home Service', id: 2 },
            { title: 'Medical', id: 3 },
            { title: 'Political', id: 4 },
            { title: 'Retail', id: 5 },
            { title: 'Staffing/HR', id: 6 },
            { title: 'Travel', id: 7 },
            { title: 'Other', id: 8 }
        ],
        firstNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        lastNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        emailModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model) || this.checkEmail(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        phoneModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model) || this.checkPhoneInvalid(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        messageModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        companyModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        topicModel: {
            value: null,
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        industryModel: {
            value: null,
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        existingCustomerModel: {
            value: 'false',
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        agree: {
            isChecked: false
        },
    }

    checkRequiredInvalid = (model) => {
        if (!this.state.isSubmitted) {
            return false;
        }
        let hasError = !model.value || !model.value.trim();
        model.errors['required'] = hasError;
        return hasError;
    }
    
    checkEmail = (model) => {
        let email = model.value;
        let hasError = !/^[A-Za-z0-9\-]+[A-Za-z0-9._\-]+@[A-Za-z0-9\-.]+\.[A-Za-z.]{2,}$/.test(email);
        model.errors['email'] = hasError;
        return hasError;
    }
    
    checkPhoneInvalid = (model) => {
        if (!this.state.isSubmitted) {
            return false;
        }
        let hasError = !isValidPhoneNumberSpecified(model.value);
        model.errors['phone'] = hasError;
        return hasError;
    }

    sent = () => {
        this.state.isSubmitted = true;
        this.setState({ isSubmitted: true, messageSent: false, messageError: false });

        this.state.firstNameModel.change(this.state.firstNameModel);
        this.state.lastNameModel.change(this.state.lastNameModel);
        this.state.emailModel.change(this.state.emailModel);
        this.state.phoneModel.change(this.state.phoneModel);
        this.state.messageModel.change(this.state.messageModel);

        if (this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.phoneModel.invalid || this.state.emailModel.invalid || this.state.messageModel.invalid) {
            return;
        }
        this.setState({ isLoading: true });
        let msg = `${this.state.messageModel.value}\r\n${this.state.agree.isChecked ? 'User agrees to receive texts from Text Request' : 'User does NOT agree to receive texts from Text Request'}`;

        var data =
        {
            FirstName: this.state.firstNameModel.value,
            LastName: this.state.lastNameModel.value,
            PhoneNumber: this.state.phoneModel.value,
            Email: this.state.emailModel.value,
            Message: msg,
            Topic: this.state.topicModel.value ? this.state.topicModel.value.title : null,
            Industry: this.state.industryModel.value ? this.state.industryModel.value.title : null,
            Company: this.state.companyModel.value,
            IsExistingCustomer: this.state.existingCustomerModel.value === 'true' ? true : false
        };

       /* const d = {};
        
        for (var p in data) {
            if (!data[p]) {
                continue;
            }
            d[encodeURIComponent(p)] = encodeURIComponent(data[p]);
        }*/
       
        const url = appConfig.url + '/webservices/Contact/SendContactFeedback';
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url,
        };
        axios(options)
        // axios.post(url, params)
        .then(() => {
            this.setState({ isLoading: false, messageSent: true, messageError: false });
        })
            .catch(() => {
                this.setState({ isLoading: false, messageSent: false, messageError: true });
            })
    }
    checkAgree() {
        this.forceUpdate();
    }
    onSubmit = e => {
        return false;
      }
    render() {
        return (
            <div class="txr-text-us-form">
                {!this.state.messageSent &&
                    <form onsubmit={this.onSubmit} class="send-us__form">
                        <div class="send-us-form__left">
                            <div class="send-us-form__item item-half txr-mr20">
                                <TxrInput model={this.state.firstNameModel} type="text" label="First name*" errors={this.state.errors}> </TxrInput>
                            </div>
                            <div class="send-us-form__item item-half">
                                <TxrInput model={this.state.lastNameModel} type="text" label="Last name*" errors={this.state.errors}> </TxrInput>
                            </div>
                            <div class="send-us-form__item">
                                <TxrInput model={this.state.emailModel} type="email" label="Email*" errors={this.state.errors}></TxrInput>
                            </div>
                            <div class="send-us-form__item">
                                <TxrInput model={this.state.phoneModel} type="text" label="Phone number*" errors={this.state.errors}></TxrInput>
                            </div>
                            <div class="send-us-form__item">
                                <TxrInputArea model={this.state.messageModel} label="Your message*" errors={this.state.errors}></TxrInputArea>
                            </div>
                        </div>
                        <div class="send-us-form__right">
                            <div class="send-us-form__topic txr-dropdown__selector">
                                <TxrDropdown model={this.state.topicModel} label="Select a topic" options={this.state.topics}></TxrDropdown>
                            </div>
                            <div class="send-us-form__industry txr-dropdown__selector">
                                <TxrDropdown model={this.state.industryModel} label="Your industry" options={this.state.industries}></TxrDropdown>
                            </div>

                            <div class="send-us-form__item company">
                                <TxrInput model={this.state.companyModel} type="text" label="Company"></TxrInput>
                            </div>

                            <div class="send-us-form__item existing-customer">
                                <div class="existing-customer__title">Are you an existing customer?</div>
                                <div class="existing-customer__value">
                                    <TxrRadioButton model={this.state.existingCustomerModel} group="customer" value="true" caption="Yes"></TxrRadioButton>
                                    <TxrRadioButton model={this.state.existingCustomerModel} group="customer" value="false" caption="No"></TxrRadioButton>
                                </div>
                            </div>

                        </div>
                        <div class="send-us-form__button">
                            <div class="checkbox-item">
                                <TxrCheckbox item={this.state.agree} select={() => this.checkAgree()}></TxrCheckbox>
                                <span>
                                I agree to receive text messages at the number provided from Text Request. Mobile information will not be shared with third parties/affiliates for marketing/promotional purposes. Text messaging originator opt-in data and consent will not be shared with any third parties. Message frequency varies. Message and data rates apply. Reply HELP for more information. Reply STOP to opt out.
                                 <br/>
                                 <a target="_blank" href="/privacy-policy" class="txr-text__link">Privacy Policy</a>,&nbsp;<a target="_blank" href="/terms-of-service" class="txr-text__link">Terms of Service</a>
                                </span>
                                
                            </div>

                            <div class="button-item">
                                <button class="txr-button txr-primary-button txr-width130" disabled={this.state.emailModel.invalid && this.state.isSubmitted} type="button" onClick={() => this.sent()}>
                                    <span class="txr-button__content"> SUBMIT
                                        {!this.state.isLoading && <i class="txr-button__angle-icon fal fa-angle-right"></i>}
                                        {this.state.isLoading && <i class="fas fa-circle-notch fa-spin"></i>}
                                    </span>
                                </button>
                            </div>
                        </div>

                    </form>
                }
                {
                    this.state.messageSent &&
                    <div class="send-us-form__sent">
                        <i class="fal fa-paper-plane"></i>
                        <div class="form-sent__title">Hooray! We got your message. Thanks for submitting it.</div>
                        <div class="form-sent__hint">We’re currently routing your message to the correct person and they’ll be in touch shortly.</div>
                    </div>
                }
                {this.state.messageError &&
                    <div class="send-us-form__error">
                        An error occurred during submit feedback
                    </div>
                }
            </div>
        )
    }
}

export default TxrTextUsForm;
